import { Avatar, Button, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleAdvancedSearchIcon } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IAdvancedSearch {
  openAdvancedSearch: Function;
  advancedSearchOpen: boolean;
  ariaControls?: string;
}

export const AdvancedSearchTitle = (props: IAdvancedSearch) => {
  const isDesktop = useIsDesktop();

  return (
    <Button
      aria-expanded={true}
      aria-controls={props.ariaControls}
      sx={{
        position: 'relative',
        width: 'fit-content',
        direction: 'row',
        alignItems: 'center',
        alignSelf: 'flex-end',
        padding: 0,
        gap: '2px',
        '&:hover': {
          cursor: 'pointer',
          textDecoration: 'underline',
          textDecorationColor: '#1552E8',
          bgcolor: 'transparent',
        },
      }}
      disableTouchRipple
      onClick={() => {
        props.openAdvancedSearch(true);
      }}
      onKeyDown={onEnterOrEscapeKeyDown}
    >
      <Avatar
        alt={''}
        src={PurpleAdvancedSearchIcon}
        sx={{
          width: isDesktop ? '24px' : '18px',
          height: isDesktop ? '24px' : '18px',
        }}
      />
      <Typography variant={'body2'} color={'primary'} component={'h2'}>
        {Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.title}
      </Typography>
    </Button>
  );
};
